// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const PanOsIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#F04E23"
      d="m10.42 15.06 7.88-7.9L15.16 4 12 7.15l1.57 1.57-7.88 7.91 3.14 3.16 3.14-3.16z"
    />
    <path
      fill="#F04E23"
      d="M8.88 4 1 11.9l3.14 3.16 7.88-7.9zM19.86 8.73l-7.88 7.9 3.14 3.16 7.88-7.9z"
    />
  </svg>,
  "PanOs",
);
export default PanOsIcon;
